module.exports = __webpack_public_path__ + "img/live3.074aa373.jpeg";